import React from "react";
import MusicData, {MUSIC_TYPE_USER} from "../../../Interfaces/MusicData";
import {UploadStatus} from "../../../Interfaces/SlideData";
import Loader from "../../Common/Loader";

interface MusicListItemProps {
    data: MusicData,
    isPlaying: boolean,
    onClick: (data: MusicData) => void,
    onDelete: (data: MusicData) => void,
}

const MusicListItem: React.FC<MusicListItemProps> = ({
                                                         data,
                                                         isPlaying,
                                                         onClick,
                                                        onDelete}) => {



    return (
        <div className={`music-item ${data.isActive ? 'active' : ''} ${data.status == UploadStatus.uploading ? 'uploading' : ''} ${data.status == UploadStatus.uploadError ? 'upload-error' : ''}`}
            onClick={() => {
                if (data.status == UploadStatus.uploadSuccess || data.status == UploadStatus.ready) {
                    onClick(data)
                }
            }}>
            <div className="inner">
                {
                    (data.status == UploadStatus.uploadSuccess || data.status == UploadStatus.ready) ?
                        (
                            <div className="play-btn">
                                <i className={`fa ${isPlaying ? 'fa-pause' : 'fa-play'}`}></i>
                            </div>
                        ) : ''
                }
                {
                    (data.status == UploadStatus.uploadError) ?
                        (
                            <div className="info">
                                <span className="title1">Ошибка загрузки</span>
                                {
                                    data.title1 !== null && typeof data.title1 !== 'undefined' && data.title1?.length > 0 ?
                                        <span className="title2"> - {data.title1}</span>
                                        : ''
                                }
                            </div>
                        ) :
                        (
                            <div className="info">
                                {
                                    data.title1 !== null && typeof data?.title1 !== 'undefined' && data?.title1?.length > 0 ?
                                        <span>
                                            <span className="title1">{data.title1}</span>
                                            {
                                                data.title2 !== null && typeof data.title2 !== 'undefined' && data.title2?.length > 0 ?
                                                    <span className="title2"> - {data.title2}</span>
                                                    : ''
                                            }
                                        </span>
                                        :
                                        <span className="title2">{data.title2}</span>
                                }
                            </div>
                        )
                }
                {
                    (data.status == UploadStatus.uploading) ?
                        (
                            <Loader showProgress={true}
                                    showBall={false}
                                    progress={data.uploadProgress as number}
                                    isLoaded={false}
                                    showTransparentImage={false}
                                    isPositionAbsolute={true}
                                    background={'transparent'}/>
                        ) : ''
                }
                {
                    (data.status == UploadStatus.uploadSuccess || data.status == UploadStatus.ready) ?
                        (
                            <div className="actions">
                                <div className="audio_remove_wrap fl_r" title="Мелодия выбрана">
                                    <div className="audio_remove"></div>
                                </div>
                            </div>
                        ) : ''
                }
                {
                    (data.status == UploadStatus.uploadSuccess || data.status == UploadStatus.ready) ?
                        (
                            <div className="duration">{data.duration ? new Date(data.duration * 1000).toISOString().substr(14, 5) : ''}</div>
                        ) : ''
                }
                {
                    (data.type == MUSIC_TYPE_USER && data.status != UploadStatus.uploading) ?
                        (
                            <div className="delete"
                                 onClick={(e: React.MouseEvent<HTMLElement>) => {
                                     e.stopPropagation();
                                     onDelete(data)
                                 }}>
                                <i className={'fa fa-trash-alt'}></i>
                            </div>
                        ) : ''
                }
            </div>
        </div>
    );
}

export default MusicListItem;